type ApolloInputType = "text" | "email" | "tel" | "textarea" | "radio_group";

export interface ApolloFieldConfig {
	label: string;
	input_type: ApolloInputType;
	auto_complete?: string;
	placeholder?: string;
	required?: boolean;
	options?: readonly string[];
}

export const APOLLO_FIELD_LIBRARY = {
	name: {
		label: "Name",
		input_type: "text",
		auto_complete: "name",
		required: true,
	},
	full_name: {
		label: "Full name",
		input_type: "text",
		auto_complete: "name",
		required: true,
	},
	email: {
		label: "Email",
		input_type: "email",
		auto_complete: "email",
		required: true,
	},
	first_name: {
		label: "First name",
		input_type: "text",
		auto_complete: "given-name",
		required: true,
	},
	last_name: {
		label: "Last name",
		input_type: "text",
		auto_complete: "family-name",
		required: true,
	},
	organization: {
		label: "Institution",
		input_type: "text",
		auto_complete: "organization",
		required: false,
	},
	org_name: {
		label: "Institution",
		input_type: "text",
		auto_complete: "organization",
		required: false,
	},
	phone: {
		label: "Phone number",
		input_type: "tel",
		auto_complete: "tel",
		required: false,
	},
	job_title: {
		label: "Job title",
		input_type: "text",
		auto_complete: "organization-title",
		required: false,
	},
	pilot_interest: {
		label: "Pilot interest",
		input_type: "radio_group",
		required: false,
		options: ["yes", "no", "maybe"],
	},
} as const satisfies Record<string, ApolloFieldConfig>;

export type ApolloFieldName = keyof typeof APOLLO_FIELD_LIBRARY;
